<template>
  <div style="width: 100%; text-align:right;">
    <v-icon @click="addNew" class="btnAdd" v-tooltip:left="{ html: 'הוסף חדש' }">add</v-icon>
    <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1 DataTable" style="padding: 20px!important; border:none; width: 100%;">
      <tr class="trPrint trHeader">
        <th class="tdData sp">שלב התקדמות</th>
        <th class="tdData">צבע</th>
        <th class="tdCtrl" style="width: 160px!important;"></th>
      </tr>
    </table>
    <div class="scrollContent" v-if="hasData">
      <table class="w3-table-all w3-hoverable w3-small w3-right-align elevation-1" style="border:none;">
        <tr v-for="row in statuses" :class="{ 'trSelect': row.selected }">
          <td class="tdData sp">{{row.Name}}</td>
          <td class="tdData tdTxt">
            <div class="divColor" :style="{ 'background-color': row.Color }"></div>
          </td>
          <td class="tdCtrl tdTxt" style="width: 160px!important;">
            <v-icon @click="edit(row)" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'עריכה' }">border_color</v-icon>
            <v-icon @click="confirm(row)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחיקה' }">delete</v-icon>
          </td>
        </tr>
      </table>
    </div>
    <div fluid v-else>
      <h3 style="padding-top: 40px;">אין נתונים</h3>
    </div>
    <PopupStatus></PopupStatus>
  </div>
</template>

<script>
  import { db } from '../firebase';
  var statusesRef = db.ref('Statuses');
  import PopupStatus from './PopupStatus';

  export default {
    name: 'TableStatuses',
    components: { PopupStatus },
    data() {
      return {
        statuses: [],
        popup: {
          isVisible: false,
          title: '',
          question: '',
          caller: '',
          isConfirmed: false,
          data: { '.key': '', Name: '', Color: '#FF0000' },
          colors: { hex: "#000000" },
        }
      }
    },
    firebase: function () {
      var vm = this;
      return {
        statuses: statusesRef.orderByKey()
      }
    },
    created() {
      this.$Log("Vue [TableStatuses] is created ...");
    },
    ready() {
      this.$Log("Vue [TableStatuses] is ready ...");
    },
    mounted() {
      this.$Log("Vue [TableStatuses] is mounted ...");
    },
    updated() {
      this.$Log("Vue [TableStatuses] is updated ...");
    },
    computed: {
      hasData() {
        return this.statuses != null && this.statuses != undefined && this.statuses.length > 0;
      },
    },
    watch: {
      '$root.confirm.isConfirmed'(val) {
        if (val && this.$root.confirm.caller == 'RemoveStatus') {
          this.remove();
        }
      }
    },
    methods: {
      addNew() {
        this.popup = {
          isVisible: true,
          isEdit: false,
          title: 'סטטוס חדש',
          data: { '.key': '', Name: '', Color: '#000000' },
          colors: { hex: "#000000" },
        };
      },
      edit(row) {
        this.popup = {
          isVisible: true,
          isEdit: true,
          title: 'עריכת סטטוס',
          data: { '.key': row['.key'], Name: row.Name, Color: row.Color },
          colors: { hex: row.Color },
        };
      },
      confirm(row) {
        this.popup.data = row;
        this.$root.confirm = {
          isVisible: true,
          title: 'מחיקה',
          question: 'האם אתה בטוח ברצונך למחוק שורה זו?',
          caller: 'RemoveStatus',
          isConfirmed: false
        }
      },
      remove() {
        statusesRef.child(this.popup.data['.key']).remove();
      },
      insert() {
        var item = { Name: this.popup.data.Name, Color: this.popup.data.Color };
        statusesRef.push(item);
      },
      update() {
        var item = { Name: this.popup.data.Name, Color: this.popup.data.Color };
        statusesRef.child(this.popup.data['.key']).set(item);
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// TableStatuses.vue?70ffc676